export const getPrescriptionLink = prescriptionId => `/prescription/${prescriptionId}`;
